export default __webpack_public_path__ + "static/media/(2).daa32530.jpg";